import React, {
    useEffect,
    useState
} from 'react';
import { 
    Navbar, 
    Container,
    Row,
    Alert,
    Spinner,
    Card,
    Badge,
    Button
} from 'react-bootstrap';
import { 
    Info
} from 'lucide-react';
import { 
    useLazyGetExpiredKYBDocumentsQuery,
    useResetExpiredKYBDocumentsMutation
} from '../app/api';

export default function ExpiredDocs(){
    const [getDocumentData] = useLazyGetExpiredKYBDocumentsQuery();
    const [resetDocumentData] = useResetExpiredKYBDocumentsMutation();
    const [gettingData, setGettingData] = useState(false);
    const [documentData, setDocumentData] = useState({
        'expired': [],
        'soonToExpire': []
    });

    const getData = async () => {
        setGettingData(true);
        const data = await getDocumentData();
        setDocumentData(data.data);
        setGettingData(false);
    }

    useEffect(()=>{   
        getData();
    }, [])

    const handleDocReset = async (doc) => {
        if(confirm('Are you sure you want to reset the documentation expiration data?')){
            const res = await resetDocumentData({
                account_type: doc.account_type,
                account_id: doc.account_id,
                data_json: JSON.stringify(doc.data_json)
            });
            console.log(res);
            getData();
        }
    }

    return (
        <>
            <Navbar bg="white" className="border-bottom shadow-sm">
                <Container fluid>
                    <Navbar.Brand className="fw-semibold p-3">
                        Accounts with Expired Documentation
                    </Navbar.Brand>
                </Container>
            </Navbar>
            <Container className="p-5">
                <Row className='mb-5'>
                    <Alert variant="info" className='d-flex align-items-center justify-content-left'>
                        <Info className='me-2'/>
                        <strong>W-8BEN</strong>&nbsp;&&nbsp;<strong>W-8BEN-E</strong>&nbsp;expire after 3 years.&nbsp;<strong>W-9</strong>&nbsp;does not expire but should be requested every 3 years.
                    </Alert>
                </Row>
                { gettingData &&
                <div className='d-flex align-items-center justify-content-center'>
                    <Spinner animation="border" style={{marginRight: '30px'}}/>
                    <span><strong>Gathering Data...</strong></span>
                </div>
                }
                { !gettingData &&
                <>
                <Row className='mb-3'>
                    <h5>Expired Documentation:</h5>
                    { documentData['expired'].length > 0 &&
                        documentData['expired'].map((doc, index) => (
                            <Card body key={'expdoc_'+index} className='mb-3'>
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        {doc.data_json.business_type}&nbsp;|&nbsp;<strong>{doc.data_json.companyName}</strong>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 flex-grow-1 justify-content-center">
                                        { !doc.data_json.business_type.includes('Non US - ') && <span>Company W9</span> }
                                        { doc.data_json.business_type.includes('Non US - ') && <span>W-8BEN-E</span> }
                                        <Badge bg="danger">Expired</Badge>
                                        <span><strong>{new Date(doc.created).toLocaleString()}</strong></span>
                                    </div>
                                    <div className="flex-grow-1 d-flex justify-content-end">
                                        <Button variant="secondary" className='me-3' onClick={()=>handleDocReset(doc)}>RESET</Button>
                                        <Button variant="primary" onClick={ () => window.location = 'cs/'+doc.account_type+'/'+doc.account_id }>VIEW ACCOUNT</Button>
                                    </div>
                                </div>
                            </Card>    
                        ))
                    }
                    { documentData['expired'].length == 0 &&
                    <Alert variant='secondary'>
                        There are no accounts with expired Documentation currently
                    </Alert>
                    }
                </Row>
                <Row>
                    <h5>Soon to be Expired Documentation (within 3 months):</h5>
                    { documentData['soonToExpire'].length > 0 &&
                        documentData['soonToExpire'].map((doc, index) => (
                            <Card body key={'s2expdoc_'+index} className='mb-3'>
                                <div className="d-flex align-items-center">
                                    <div className="flex-grow-1">
                                        {doc.data_json.business_type}&nbsp;|&nbsp;<strong>{doc.data_json.companyName}</strong>
                                    </div>
                                    <div className="d-flex align-items-center gap-2 flex-grow-1 justify-content-center">
                                        { !doc.data_json.business_type.includes('Non US - ') && <span>Company W9</span> }
                                        { doc.data_json.business_type.includes('Non US - ') && <span>W-8BEN-E</span> }
                                        <Badge bg="warning">Soon To Expire</Badge>
                                        <span><strong>{new Date(doc.created).toLocaleString()}</strong></span>
                                    </div>
                                    <div className="flex-grow-1 d-flex justify-content-end">
                                        <Button variant="secondary" className='me-3'>RESET</Button>
                                        <Button variant="primary" onClick={ () => window.location = 'cs/'+doc.account_type+'/'+doc.account_id }>VIEW ACCOUNT</Button>
                                    </div>
                                </div>
                            </Card>    
                        ))
                    }
                    { documentData['soonToExpire'].length == 0 &&
                    <Alert variant='secondary'>
                        There are no accounts with documentation expiring within 3 months
                    </Alert>
                    }
                </Row>
                </>
                }
            </Container>
        </>
    )
};